import { supabase } from '@/lib/supabase';
import { ApiUpdateDashboardProjectSlotsInput } from '@/shared/types/api';

export const getDashboardProjectSlots = async (orgId: number) => {
  const { data, error } = await supabase
    .from('dashboard_project_slots')
    .select('*')
    .eq('org_id', orgId)
    .maybeSingle();

  if (error) {
    throw error;
  }

  return data;
};

export const upsertDashboardProjectSlots = async (
  orgId: number,
  updates: ApiUpdateDashboardProjectSlotsInput,
) => {
  const { data, error } = await supabase
    .from('dashboard_project_slots')
    .upsert(
      {
        org_id: orgId,
        ...updates,
      },
      {
        onConflict: 'org_id',
      },
    )
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export type UpdateDashboardProjectSlotInput = {
  slotIndex: number;
  projectId: number | null;
  isActive?: boolean;
};

export const updateDashboardProjectSlot = async ({
  orgId,
  slotIndex,
  projectId,
  isActive,
}: UpdateDashboardProjectSlotInput & { orgId: number }) => {
  const updateData: Record<string, number | null | boolean> = {
    [`slot_${slotIndex}_project_id`]: projectId,
  };

  if (isActive !== undefined) {
    updateData[`slot_${slotIndex}_is_active`] = isActive;
  }

  return upsertDashboardProjectSlots(orgId, updateData);
};
